<app-page-title [title]="'Selected Score Recipients'"></app-page-title>

<br />

<div class="row">
    <table class="table table-hover">
        <thead>
            <tr>
                <th>Country</th>
                <th>Institution</th>
                <th>Student Number</th>
                <th>Academic Level</th>
                <th>Order Date</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let institution of institutions">
                <td>{{institution.country.name}}</td>
                <td>{{institution.institutionName}}</td>
                <td>{{institution.studentNumber}}</td>
                <td>{{institution.academicLevel}}</td>
                <td>{{institution.dateCreatedUtc | date : format : "yyyy-MM-dd" }}</td>
            </tr>
        </tbody>
    </table>
</div>
